import { FC } from "react";

import PlaidLinkDialog from "./PlaidLinkDialog";

const VerifyInvestor: FC = () => {
  return <PlaidLinkDialog />;
};

export default VerifyInvestor;
